<template>
  <v-dialog scrollable v-model="dialog" max-width="650px">
    <v-card style="border-radius:20px;" class="py-2 strategio-card-container">
      <v-card-title class="py-2 justify-center" style="font-size:20px;font-weight:500;" >
        {{isNew ? 'Crear reporte' : 'Editar reporte'}} {{heritable ? 'base' : ''}}
      </v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        <template v-if="!heritable">
          <v-select
            bottom
            item-text="name"
            item-value="type"
            :items="[
              {name: 'Reporte Excel', type: 0},
              {name: 'Dashboard PowerBI', type: 1},
              {name: 'Sabana de datos', type: 2},
              {name: 'Dashboard Embed', type: 3},
            ]"
            persistent-hint
            label="Tipo de reporte"
            v-model="data.reportType"
          ></v-select>
          <v-text-field
            label="Nombre de reporte *"
            v-model="data.reportName"
            :rules="[validateReportName(), validateForm()]"
            clearable
          ></v-text-field>
          <v-text-field
            label="Descripcion"
            v-model="data.description"
            clearable
          ></v-text-field>
          <v-text-field
            label="URL principal *"
            v-model="data.url1"
            :rules="[validateUrls(), validateForm()]"
            hint="Esta URL es opcional si ya tenemos URL de descarga"
            clearable
          ></v-text-field>
          <v-text-field
            label="URL de descarga *"
            v-model="data.url2"
            :rules="[validateUrls(), validateForm()]"
            hint="Esta URL es opcional si ya tenemos URL principal"
            clearable
          ></v-text-field>
          <v-text-field
            label="URL 3"
            v-model="data.url3"
            clearable
          ></v-text-field>
          <v-text-field
            label="URL 4"
            v-model="data.url4"
            clearable
          ></v-text-field>
          <v-text-field
            label="URL 5"
            v-model="data.url5"
            clearable
          ></v-text-field>
          <v-text-field
            label="URL de imagen"
            v-model="data.imageUrl"
            clearable
          ></v-text-field>
          <v-text-field
            label="Labels"
            v-model="data.labels"
            clearable
          ></v-text-field>
        </template>
        <template v-else>
          <v-text-field
            label="Nombre de reporte *"
            v-model="data.reportName"
            :rules="[validateReportName(), validateForm()]"
            clearable
          ></v-text-field>
          <v-text-field
            label="Descripcion"
            v-model="data.description"
            clearable
          ></v-text-field>
          <v-text-field
            label="URL de imagen"
            v-model="data.imageUrl"
            clearable
          ></v-text-field>
          <v-text-field
            label="Labels"
            v-model="data.labels"
            clearable
            :prefix="isNew ? labelsPrefix : ''"
            class="input-group--focused"
          ></v-text-field>
        </template>
      </v-card-text>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-actions class="layout justify-center">
        <v-btn
          small dark depressed rounded
          class="strategio-dialog-button"
          color="red"
          @click.native="dialog = false"
        >Cerrar</v-btn>
        <v-btn
          small depressed rounded
          class="strategio-dialog-button"
          color="success"
          :disabled="!isValidForm || isLoading"
          @click.native="sendNewData()"
        >Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {omit} from 'lodash'

import eventBus from '../../utils/eventBus'
import reportsStorage from '../../storage/reportsStorage'
import structureStorage from '../../storage/structureStorage'

export default {
  name: 'report-form-dialog',
  data () {
    return {
      dialog: false,
      // dialog: true,
      reportID: '',
      parentName: '',
      containedBy: '',
      structureID: '',
      data: {
        reportName: '',
        description: '',
        url1: '',
        url2: '',
        url3: '',
        url4: '',
        url5: '',
        imageUrl: '',
        labels: '',
        inherited: 0 // Sospechoso, aunque parece que no se usa para actualizar valores, osea, no hay problema
      },
      isValidForm: false,
      isNew: false,
      // isNew: true,
      heritable: false,
      isLoading: false
    }
  },
  computed: {
    labelsPrefix () {
      // return `${this.parentName}, ${this.data.reportName ? (this.data.labels ? this.data.reportName + ', ' : this.data.reportName) : ''}`
      return `${'$$FOLDER'}, ${this.data.reportName ? (this.data.labels ? this.data.reportName + ', ' : this.data.reportName) : ''}`
    }
  },
  methods: {
    hasStructureItemInheritance () {
      // console.log('???', 'containedBy', this.containedBy)
      // console.log('???', `containedBy.startsWith('HI')`, this.containedBy.startsWith('HI'))
      return this.containedBy.startsWith('HI')
    },
    sendNewData () {
      if (!this.isValidForm) {
        return
      }
      this.isLoading = true
      if (this.isNew) {
        if (this.heritable) {
          // Crear estructura correspondiente, más los items en las carpetas
          //  que tienen como heredable a esta estructura
          let _containedBy = this.containedBy
          structureStorage.createHeritableItem({
            data: {
              structureID: this.structureID,
              itemName: this.data.reportName,
              ...omit(this.data, 'labels'),
              labels: this.labelsPrefix + this.data.labels,
              isFolder: false,
              containedBy: _containedBy,
              structureItemInheritance: this.hasStructureItemInheritance()
            },
            onSuccess: (result) => {
              // eventBus.$emit('open-custom-snack-bar', {message: 'Reporte heredable creado exitosamente', itsOk: true})
              eventBus.$emit('open-custom-snack-bar', {message: 'Reporte heredable creado exitosamente', itsOk: true})
              // emit to routes/main-page.vue
              eventBus.$emit('reload-items')
              this.dialog = false

              // console.log('???', 'result', JSON.stringify(result, null, 2), result)
              if (result.length > 0) {
                eventBus.$emit('open-new-items-manager-dialog', {
                  items: result
                })
              }
              this.isLoading = false
            },
            onError: (error) => {
              console.warn('error creando reporte heredable: ', error)
              eventBus.$emit('open-custom-snack-bar', {message: 'No se ha podido crear el reporte heredable', itsOk: false})
              this.isLoading = false
            }
          })
        } else {
          reportsStorage.addItem({
            data: {
              itemName: this.data.reportName,
              ...this.data,
              isFolder: false,
              containedBy: this.containedBy,
              inherited: 0,
              structureItemInheritance: false
            },
            onSuccess: () => {
              eventBus.$emit('open-custom-snack-bar', {message: 'Se ha creado el reporte correctamente', itsOk: true})
              // emit to routes/main-page.vue
              eventBus.$emit('reload-items')
              this.dialog = false
              this.isLoading = false
            },
            onError: (error) => {
              console.warn('error creando reporte: ', error)
              eventBus.$emit('open-custom-snack-bar', {message: 'No se ha podido guardar el reporte', itsOk: false})
              this.isLoading = false
            }
          })
        }
      } else {
        if (this.heritable) {
          structureStorage.updateHeritableItem({
            data: {
              containedBy: this.containedBy,
              structureID: this.structureID,
              isFolder: false,
              itemID: this.reportID,
              itemName: this.data.reportName,
              description: this.data.description,
              labels: this.data.labels,
              imageUrl: this.data.imageUrl,
              removed: false
            },
            onSuccess: () => {
              eventBus.$emit('open-custom-snack-bar', {message: 'Se ha actualizado el reporte heredable correctamente', itsOk: true})
              // emit to routes/main-page.vue
              eventBus.$emit('reload-items')
              this.dialog = false
              this.isLoading = false
            },
            onError: (error) => {
              console.warn('Error updating a heritable report: ', error)
              eventBus.$emit('open-custom-snack-bar', {message: 'Ocurrió un problema actualizando el reporte heredable', itsOk: false})
              this.isLoading = false
            }
          })
        } else {
          reportsStorage.editItem({itemID: this.reportID}, {
            itemName: this.data.reportName,
            url1: this.data.url1,
            url2: this.data.url2,
            url3: this.data.url3,
            url4: this.data.url4,
            url5: this.data.url5,
            imageUrl: this.data.imageUrl,
            description: this.data.description,
            labels: this.data.labels,
            isFolder: false
          }, {
            onSuccess: () => {
              eventBus.$emit('open-custom-snack-bar', {message: 'Se ha actualizado el reporte correctamente', itsOk: true})
              this.dialog = false
              this.isLoading = false
            },
            onError: (error) => {
              console.warn('Error updating a report: ', error)
              eventBus.$emit('open-custom-snack-bar', {message: 'Ocurrió un problema actualizando el reporte', itsOk: false})
              this.isLoading = false
            }
          })
        }
      }
    },
    validateReportName () {
      if (this.data.reportName && this.data.reportName.trim() !== '') {
        return true
      }
      return 'Este campo es obligatorio'
    },
    validateUrls () {
      if ((this.data.url1 && this.data.url1.trim() !== '') || (this.data.url2 && this.data.url2.trim() !== '')) {
        return true
      }
      return 'Este campo es obligatorio'
    },
    validateForm () {
      const isValidReportName = (this.data.reportName && this.data.reportName.trim() !== '')
      const isValidUrls = ((this.data.url1 && this.data.url1.trim() !== '') || (this.data.url2 && this.data.url2.trim() !== ''))
      if (this.heritable) {
        this.isValidForm = isValidReportName
      } else {
        this.isValidForm = isValidReportName && isValidUrls
      }
      return true
    }
  },
  created () {
    eventBus.$off('open-report-form')
    eventBus.$on('open-report-form', (item) => {
      this.heritable = item.heritable
      this.isNew = !('itemID' in item)
      this.containedBy = item.containedBy
      this.reportID = item.itemID
      this.parentName = item.parentName
      this.structureID = item.structureID

      this.data = {
        reportName: item.itemName || '',
        description: item.description || '',
        url1: item.url1 || '',
        url2: item.url2 || '',
        url3: item.url3 || '',
        url4: item.url4 || '',
        url5: item.url5 || '',
        imageUrl: item.imageUrl || '',
        labels: item.labels || ''
      }
      this.dialog = true
      this.isLoading = false
    })
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/report-form-dialog.vue